/** @jsx builderX.jsx */

import { builderX, Sprite, Image, Text, Button, Graphic } from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name='bottomPanel'>
        <Graphic position={[0, 2160]} width={3840} height={76} alpha={1.0} name='bg' color='#000000' />
        <Button position={[60, 2175]} hitArea={{ width: 52, x: 0, y: 0, type: 'rectangle', height: 46 }} name='homeButton'>
            <Sprite>
                <Image src='home_normal' />
            </Sprite>
            <Sprite>
                <Image src='home_focused' />
            </Sprite>
            <Sprite>
                <Image src='home_focused' />
            </Sprite>
            <Sprite>
                <Image src='home_disabled' />
            </Sprite>
        </Button>
        <Sprite position={[154, 1913]} name='soundPanel'>
            <Sprite name='soundBar'>
                <Image name='bg' src='soun_settings_bg' />
                <Sprite position={[35, 16]} name='fullSlider'>
                    <Image name='fullLine' src='sound_settings_full' />
                </Sprite>
                <Sprite position={[41, 18]} name='thumbButtonContainer'>
                    <Button hitArea={{ width: -1, x: 0, y: 0, type: 'rectangle', height: -1 }} name='thumbButton'>
                        <Sprite>
                            <Image anchor={[0.5, 0.5]} name='thumb' src='sound_settings_thumb' />
                        </Sprite>
                        <Sprite>
                            <Image anchor={[0.5, 0.5]} name='thumb' src='sound_settings_thumb' />
                        </Sprite>
                        <Sprite>
                            <Image anchor={[0.5, 0.5]} name='thumb' src='sound_settings_thumb' />
                        </Sprite>
                        <Sprite>
                            <Image anchor={[0.5, 0.5]} name='thumb' src='sound_settings_thumb' />
                        </Sprite>
                    </Button>
                </Sprite>
            </Sprite>
            <Button position={[18, 262]} hitArea={{ width: 78, x: -16, y: -16, type: 'rectangle', height: 71 }} name='soundOnButton'>
                <Sprite>
                    <Image src='sound_normal' />
                </Sprite>
                <Sprite>
                    <Image src='sound_focused' />
                </Sprite>
                <Sprite>
                    <Image src='sound_focused' />
                </Sprite>
                <Sprite>
                    <Image src='sound_disabled' />
                </Sprite>
            </Button>
            <Button position={[18, 262]} hitArea={{ width: 78, x: -16, y: -16, type: 'rectangle', height: 71 }} name='soundOffButton'>
                <Sprite>
                    <Image src='no_sound_normal' />
                </Sprite>
                <Sprite>
                    <Image src='no_sound_focused' />
                </Sprite>
                <Sprite>
                    <Image src='no_sound_focused' />
                </Sprite>
                <Sprite>
                    <Image src='no_sound_disabled' />
                </Sprite>
            </Button>
        </Sprite>
        <Button position={[285, 2176]} hitArea={{ width: 29, x: 0, y: 0, type: 'rectangle', height: 47 }} name='gameRulesButton'>
            <Sprite>
                <Image src='game_rules_normal' />
            </Sprite>
            <Sprite>
                <Image src='game_rules_focused' />
            </Sprite>
            <Sprite>
                <Image src='game_rules_focused' />
            </Sprite>
            <Sprite>
                <Image src='game_rules_disabled' />
            </Sprite>
        </Button>
        <Button position={[375, 2175]} hitArea={{ width: 62, x: 0, y: 0, type: 'rectangle', height: 46 }} name='fullscreenButton'>
            <Sprite>
                <Image src='fullscreen_normal' />
            </Sprite>
            <Sprite>
                <Image src='fullscreen_focused' />
            </Sprite>
            <Sprite>
                <Image src='fullscreen_focused' />
            </Sprite>
            <Sprite>
                <Image src='fullscreen_disabled' />
            </Sprite>
        </Button>
        <Button position={[481, 2175]} hitArea={{ width: 47, x: 0, y: 0, type: 'rectangle', height: 47 }} name='cashierButton'>
            <Sprite>
                <Image src='cashiere_normal' />
            </Sprite>
            <Sprite>
                <Image src='cashiere_focused' />
            </Sprite>
            <Sprite>
                <Image src='cashiere_focused' />
            </Sprite>
            <Sprite>
                <Image src='cashiere_disabled' />
            </Sprite>
        </Button>
        <Button position={[572, 2175]} hitArea={{ width: -1, x: 0, y: 0, type: 'rectangle', height: -1 }} name='historyButton'>
            <Sprite>
                <Image src='history_normal' />
            </Sprite>
            <Sprite>
                <Image src='history_focused' />
            </Sprite>
            <Sprite>
                <Image src='history_focused' />
            </Sprite>
            <Sprite>
                <Image src='history_disabled' />
            </Sprite>
        </Button>
        <Button position={[655, 2175]} hitArea={{ width: -1, x: 0, y: 0, type: 'rectangle', height: -1 }} name='supportButton'>
            <Sprite>
                <Image src='support_normal' />
            </Sprite>
            <Sprite>
                <Image src='support_focused' />
            </Sprite>
            <Sprite>
                <Image src='support_focused' />
            </Sprite>
            <Sprite>
                <Image src='support_disabled' />
            </Sprite>
        </Button>
        <Button position={[740, 2175]} hitArea={{ width: -1, x: 0, y: 0, type: 'rectangle', height: -1 }} name='logoutButton'>
            <Sprite>
                <Image src='logout_normal' />
            </Sprite>
            <Sprite>
                <Image src='logout_focused' />
            </Sprite>
            <Sprite>
                <Image src='logout_focused' />
            </Sprite>
            <Sprite>
                <Image src='logout_disabled' />
            </Sprite>
        </Button>
        <Sprite position={[955, 2163]} name='balancePanel' >
            <Text
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 55,
                    fontStyle: 'normal',
                    fill: '#FFD200',
                    align: 'left',
                    fontWeight: 'bold'
                }}
                maxWidth={800}
                name='fieldText'
                localeTextID=''
                text='$20000.00'
            />
        </Sprite>
        <Sprite position={[1555, 2163]} name='pointsBalance' >
            <Text
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 55,
                    fontStyle: 'normal',
                    fill: '#FFFFFF',
                    align: 'left',
                    fontWeight: 'bold'
                }}
                maxWidth={800}
                name='fieldText'
                localeTextID=''
                text=''
            />
        </Sprite>
    </Sprite>
);
